'use client';

import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { BANNER_QUERIES } from '../../infrastructure/banner/utils/queries';
import type { GetBannersRequest } from '../../infrastructure/banner/utils/types';

export const useBannerService = () => {
  const useGetBannersSuspenseQuery = (params: GetBannersRequest = { location: '/' }) => {
    return useSuspenseQuery(BANNER_QUERIES.getBanners(params));
  };
  const useGetBannersQuery = (params: GetBannersRequest = { location: '/' }) => {
    return useQuery(BANNER_QUERIES.getBanners(params));
  };

  return {
    useGetBannersSuspenseQuery,
    useGetBannersQuery,
  };
};
